'use strict';

var MarketProductGroupSeasonFilterFactory = function MarketProductGroupSeasonFilterFactory(DataFilter, SeasonLabelFormattingService) {
  function MarketProductGroupSeasonFilter() {
    this.sourceType = ['market-product-group', 'market'];
    this.filterType = 'seasons';
  }
  MarketProductGroupSeasonFilter.constructor = MarketProductGroupSeasonFilter;
  MarketProductGroupSeasonFilter.prototype = Object.create(DataFilter.prototype);
  MarketProductGroupSeasonFilter.prototype.groupBy = ['seasonOverride', 'season'];
  MarketProductGroupSeasonFilter.prototype.filter = function (data, range) {
    var convertedRange = [];
    for (var i = 0, len = range.length; i < len; i++) {
      var element = range[i];
      var newElement = SeasonLabelFormattingService.formatSeasonFilter(element);
      convertedRange.push(newElement ? newElement.replace(/\s/g, '').toLowerCase() : newElement);
    }
    return DataFilter.prototype.filter(data, convertedRange, this.groupBy);
  };
  return MarketProductGroupSeasonFilter;
};
MarketProductGroupSeasonFilterFactory.$inject = ['DataFilterFactory', 'SeasonLabelFormattingService'];
module.exports = MarketProductGroupSeasonFilterFactory;